var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFolderOutline16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.5l-2-3h-5V13A1.5 1.5 0 002 14.5h12a1.5 1.5 0 001.5-1.5V4.5z",
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgFolderOutline16;